"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCheckDigit = exports.getEquivalentBarcodes = exports.getBarcodeFormat = exports.BarcodeFormat = void 0;
const errors_1 = require("@deliverr/errors");
var BarcodeFormat;
(function (BarcodeFormat) {
    BarcodeFormat["ASIN"] = "asin";
    BarcodeFormat["DSKU"] = "dsku";
    BarcodeFormat["EAN"] = "ean";
    BarcodeFormat["FNSKU"] = "fnsku";
    BarcodeFormat["GTIN14"] = "gtin14";
    BarcodeFormat["UNKNOWN"] = "";
    BarcodeFormat["UPC"] = "upc";
    BarcodeFormat["WISHSKU"] = "wishsku";
    BarcodeFormat["CDSKU"] = "cdsku";
    BarcodeFormat["DELIVERR_RETURN"] = "deliverr_return";
    BarcodeFormat["DPID"] = "dpId";
    BarcodeFormat["FPID"] = "fpId";
})(BarcodeFormat = exports.BarcodeFormat || (exports.BarcodeFormat = {}));
const BARCODE_PATTERNS = {
    [BarcodeFormat.DSKU]: /^D\w{10}$/,
    [BarcodeFormat.FNSKU]: /^B\w{9}$|^X00\w{7}$/,
    [BarcodeFormat.UPC]: /^\d{12}$/,
    [BarcodeFormat.EAN]: /^\d{13}$/,
    [BarcodeFormat.GTIN14]: /^\d{14}$/,
    [BarcodeFormat.WISHSKU]: /^WI\w{12}$/,
    [BarcodeFormat.CDSKU]: /^CD[A-Z0-9]{9}$/,
    [BarcodeFormat.DELIVERR_RETURN]: /^E423\w{8}$/,
    [BarcodeFormat.DPID]: /^DP[A-Z0-9]{6}$/,
    [BarcodeFormat.FPID]: /^FPID[A-Z0-9]{16}$/,
};
const BARCODE_PATTERNS_STRICT = {
    ...BARCODE_PATTERNS,
    [BarcodeFormat.ASIN]: /^B\w{9}$/,
    [BarcodeFormat.FNSKU]: /^X00\w{7}$/,
};
const getBarcodeFormat = (barcode, options) => {
    if (!barcode) {
        return BarcodeFormat.UNKNOWN;
    }
    const pattern = options?.strict ? BARCODE_PATTERNS_STRICT : BARCODE_PATTERNS;
    const matchingPattern = Object.entries(pattern).find(([, regex]) => Boolean(barcode.match(regex)));
    return matchingPattern ? matchingPattern[0] : BarcodeFormat.UNKNOWN;
};
exports.getBarcodeFormat = getBarcodeFormat;
const getEquivalentBarcodes = (barcode, format) => {
    if (format === BarcodeFormat.EAN && barcode.startsWith("0")) {
        return [barcode.slice(1), barcode, zeroPadBarcode(barcode, 1)];
    }
    if (format === BarcodeFormat.GTIN14 && barcode.startsWith("00")) {
        return [barcode.slice(2), barcode.slice(1), barcode];
    }
    if (format === BarcodeFormat.UPC) {
        return [barcode, zeroPadBarcode(barcode, 1), zeroPadBarcode(barcode, 2)];
    }
    return [barcode];
};
exports.getEquivalentBarcodes = getEquivalentBarcodes;
const getCheckDigit = (barcode) => {
    if (barcode.length > 13 || barcode.length < 11 || !/^\d+$/.test(barcode)) {
        throw new errors_1.DeliverrError({
            code: "BARCODE_ERROR",
            subcode: "INVALID_TYPE",
            message: "check digit check sum calculation is only valid for UPC, EAN and GTIN14 barcode formats",
        });
    }
    const array = barcode.split("").reverse();
    let total = 0;
    array.forEach((number, index) => {
        const num = Number(number);
        total = (index + 1) % 2 === 0 ? total + num : total + num * 3;
    });
    return Math.ceil(total / 10) * 10 - total;
};
exports.getCheckDigit = getCheckDigit;
const zeroPadBarcode = (barcode, zeroPadAmount) => {
    return "0".repeat(zeroPadAmount).concat(barcode);
};
//# sourceMappingURL=BarcodeUtils.js.map